export default {
  infoLabel: 'Informações do Componente',
  closeLabel: 'Fechar informações',
  profilePicture: 'Foto de perfil',
  name: 'Nome',
  username: 'Username',
  interactions: 'Total',
  comments: 'Comentários',
  inboxes: 'Inboxes',
  page: 'Página',
  channel: 'Canal',
  polarity: 'Polaridade',
  posts: 'Publicações',
  faq: {
    faq01: {
      title: 'De onde vem os dados da tabela?',
      description: 'Dá área de usuários mais engajados do Métricas Proprietárias',
    },
    faq02: {
      title: 'Quais canais é possível utilizar esses dados?',
      description: 'Instagram e Facebook',
    },
    faq03: {
      title: 'O que significa a coluna Total?',
      description: 'Total é a soma de publicações, comentários e inbox',
    },
  },
};
